import type {
  AnalyticsEventMap,
  AnalyticsEventName,
  SanitizedAnalyticsCapture,
} from "./events";

export type AnalyticsTransport = Readonly<{
  capture: (capture: SanitizedAnalyticsCapture) => void;
}>;

export type AnalyticsClient = Readonly<{
  capture: <K extends AnalyticsEventName>(
    event: K,
    properties: AnalyticsEventMap[K],
  ) => void;
  attachTransport: (transport: AnalyticsTransport) => void;
  disable: () => void;
}>;

export const NOOP_ANALYTICS_CLIENT: AnalyticsClient = Object.freeze({
  capture: () => undefined,
  attachTransport: () => undefined,
  disable: () => undefined,
});
